// source: job.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var general_pb = require('./general_pb.js');
goog.object.extend(proto, general_pb);
var drive_pb = require('./drive_pb.js');
goog.object.extend(proto, drive_pb);
var entity_pb = require('./entity_pb.js');
goog.object.extend(proto, entity_pb);
var task_pb = require('./task_pb.js');
goog.object.extend(proto, task_pb);
var enums_pb = require('./enums_pb.js');
goog.object.extend(proto, enums_pb);
goog.exportSymbol('proto.cloud.JobDetails', null, global);
goog.exportSymbol('proto.cloud.JobFolder', null, global);
goog.exportSymbol('proto.cloud.JobFolder.DirectoryChildren', null, global);
goog.exportSymbol('proto.cloud.JobFolder.FileChildren', null, global);
goog.exportSymbol('proto.cloud.JobInfoIngest', null, global);
goog.exportSymbol('proto.cloud.JobInfoQuery', null, global);
goog.exportSymbol('proto.cloud.JobInfoQueryExpansionRequest', null, global);
goog.exportSymbol('proto.cloud.JobItemLocations', null, global);
goog.exportSymbol('proto.cloud.JobItemLocations.Location', null, global);
goog.exportSymbol('proto.cloud.JobNode', null, global);
goog.exportSymbol('proto.cloud.JobNode.Destinations', null, global);
goog.exportSymbol('proto.cloud.JobReport', null, global);
goog.exportSymbol('proto.cloud.JobSnapshot', null, global);
goog.exportSymbol('proto.cloud.JobTasks', null, global);
goog.exportSymbol('proto.cloud.MediaDerivative', null, global);
goog.exportSymbol('proto.cloud.MediaSource', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.JobDetails.repeatedFields_, null);
};
goog.inherits(proto.cloud.JobDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobDetails.displayName = 'proto.cloud.JobDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobInfoIngest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.JobInfoIngest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobInfoIngest.displayName = 'proto.cloud.JobInfoIngest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobInfoQuery = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.JobInfoQuery.repeatedFields_, null);
};
goog.inherits(proto.cloud.JobInfoQuery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobInfoQuery.displayName = 'proto.cloud.JobInfoQuery';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobInfoQueryExpansionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.JobInfoQueryExpansionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobInfoQueryExpansionRequest.displayName = 'proto.cloud.JobInfoQueryExpansionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobTasks = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.JobTasks, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobTasks.displayName = 'proto.cloud.JobTasks';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobSnapshot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.JobSnapshot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobSnapshot.displayName = 'proto.cloud.JobSnapshot';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.JobNode.repeatedFields_, null);
};
goog.inherits(proto.cloud.JobNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobNode.displayName = 'proto.cloud.JobNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobNode.Destinations = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.JobNode.Destinations.repeatedFields_, null);
};
goog.inherits(proto.cloud.JobNode.Destinations, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobNode.Destinations.displayName = 'proto.cloud.JobNode.Destinations';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobFolder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.JobFolder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobFolder.displayName = 'proto.cloud.JobFolder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobFolder.DirectoryChildren = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.JobFolder.DirectoryChildren, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobFolder.DirectoryChildren.displayName = 'proto.cloud.JobFolder.DirectoryChildren';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobFolder.FileChildren = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.JobFolder.FileChildren.repeatedFields_, null);
};
goog.inherits(proto.cloud.JobFolder.FileChildren, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobFolder.FileChildren.displayName = 'proto.cloud.JobFolder.FileChildren';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.JobReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobReport.displayName = 'proto.cloud.JobReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.MediaDerivative = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.MediaDerivative.repeatedFields_, null);
};
goog.inherits(proto.cloud.MediaDerivative, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.MediaDerivative.displayName = 'proto.cloud.MediaDerivative';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.MediaSource = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.MediaSource, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.MediaSource.displayName = 'proto.cloud.MediaSource';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobItemLocations = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.cloud.JobItemLocations.repeatedFields_, null);
};
goog.inherits(proto.cloud.JobItemLocations, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobItemLocations.displayName = 'proto.cloud.JobItemLocations';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.cloud.JobItemLocations.Location = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.cloud.JobItemLocations.Location, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.cloud.JobItemLocations.Location.displayName = 'proto.cloud.JobItemLocations.Location';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.JobDetails.repeatedFields_ = [11,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    jobType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    dateStarted: jspb.Message.getFieldWithDefault(msg, 5, ""),
    dateFinished: jspb.Message.getFieldWithDefault(msg, 6, ""),
    countFolders: jspb.Message.getFieldWithDefault(msg, 7, 0),
    countFiles: jspb.Message.getFieldWithDefault(msg, 8, 0),
    bytes: jspb.Message.getFieldWithDefault(msg, 9, 0),
    volumeFoldersList: jspb.Message.toObjectList(msg.getVolumeFoldersList(),
    drive_pb.VolumeFolder.toObject, includeInstance),
    tagsList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f,
    application: (f = msg.getApplication()) && general_pb.Application.toObject(includeInstance, f),
    machine: (f = msg.getMachine()) && general_pb.Machine.toObject(includeInstance, f),
    manifestId: jspb.Message.getFieldWithDefault(msg, 66, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobDetails}
 */
proto.cloud.JobDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobDetails;
  return proto.cloud.JobDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobDetails}
 */
proto.cloud.JobDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {!proto.cloud.JobType} */ (reader.readEnum());
      msg.setJobType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateStarted(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateFinished(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCountFolders(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCountFiles(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBytes(value);
      break;
    case 11:
      var value = new drive_pb.VolumeFolder;
      reader.readMessage(value,drive_pb.VolumeFolder.deserializeBinaryFromReader);
      msg.addVolumeFolders(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 64:
      var value = new general_pb.Application;
      reader.readMessage(value,general_pb.Application.deserializeBinaryFromReader);
      msg.setApplication(value);
      break;
    case 65:
      var value = new general_pb.Machine;
      reader.readMessage(value,general_pb.Machine.deserializeBinaryFromReader);
      msg.setMachine(value);
      break;
    case 66:
      var value = /** @type {string} */ (reader.readString());
      msg.setManifestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getJobType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getDateStarted();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDateFinished();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCountFolders();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getCountFiles();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getBytes();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getVolumeFoldersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      drive_pb.VolumeFolder.serializeBinaryToWriter
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
  f = message.getApplication();
  if (f != null) {
    writer.writeMessage(
      64,
      f,
      general_pb.Application.serializeBinaryToWriter
    );
  }
  f = message.getMachine();
  if (f != null) {
    writer.writeMessage(
      65,
      f,
      general_pb.Machine.serializeBinaryToWriter
    );
  }
  f = message.getManifestId();
  if (f.length > 0) {
    writer.writeString(
      66,
      f
    );
  }
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.cloud.JobDetails.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobDetails} returns this
 */
proto.cloud.JobDetails.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional JobType job_type = 4;
 * @return {!proto.cloud.JobType}
 */
proto.cloud.JobDetails.prototype.getJobType = function() {
  return /** @type {!proto.cloud.JobType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.cloud.JobType} value
 * @return {!proto.cloud.JobDetails} returns this
 */
proto.cloud.JobDetails.prototype.setJobType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string date_started = 5;
 * @return {string}
 */
proto.cloud.JobDetails.prototype.getDateStarted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobDetails} returns this
 */
proto.cloud.JobDetails.prototype.setDateStarted = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string date_finished = 6;
 * @return {string}
 */
proto.cloud.JobDetails.prototype.getDateFinished = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobDetails} returns this
 */
proto.cloud.JobDetails.prototype.setDateFinished = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 count_folders = 7;
 * @return {number}
 */
proto.cloud.JobDetails.prototype.getCountFolders = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.JobDetails} returns this
 */
proto.cloud.JobDetails.prototype.setCountFolders = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 count_files = 8;
 * @return {number}
 */
proto.cloud.JobDetails.prototype.getCountFiles = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.JobDetails} returns this
 */
proto.cloud.JobDetails.prototype.setCountFiles = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 bytes = 9;
 * @return {number}
 */
proto.cloud.JobDetails.prototype.getBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.JobDetails} returns this
 */
proto.cloud.JobDetails.prototype.setBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * repeated VolumeFolder volume_folders = 11;
 * @return {!Array<!proto.cloud.VolumeFolder>}
 */
proto.cloud.JobDetails.prototype.getVolumeFoldersList = function() {
  return /** @type{!Array<!proto.cloud.VolumeFolder>} */ (
    jspb.Message.getRepeatedWrapperField(this, drive_pb.VolumeFolder, 11));
};


/**
 * @param {!Array<!proto.cloud.VolumeFolder>} value
 * @return {!proto.cloud.JobDetails} returns this
*/
proto.cloud.JobDetails.prototype.setVolumeFoldersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.cloud.VolumeFolder=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.VolumeFolder}
 */
proto.cloud.JobDetails.prototype.addVolumeFolders = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.cloud.VolumeFolder, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.JobDetails} returns this
 */
proto.cloud.JobDetails.prototype.clearVolumeFoldersList = function() {
  return this.setVolumeFoldersList([]);
};


/**
 * repeated string tags = 12;
 * @return {!Array<string>}
 */
proto.cloud.JobDetails.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.cloud.JobDetails} returns this
 */
proto.cloud.JobDetails.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.cloud.JobDetails} returns this
 */
proto.cloud.JobDetails.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.JobDetails} returns this
 */
proto.cloud.JobDetails.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * optional Application application = 64;
 * @return {?proto.cloud.Application}
 */
proto.cloud.JobDetails.prototype.getApplication = function() {
  return /** @type{?proto.cloud.Application} */ (
    jspb.Message.getWrapperField(this, general_pb.Application, 64));
};


/**
 * @param {?proto.cloud.Application|undefined} value
 * @return {!proto.cloud.JobDetails} returns this
*/
proto.cloud.JobDetails.prototype.setApplication = function(value) {
  return jspb.Message.setWrapperField(this, 64, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobDetails} returns this
 */
proto.cloud.JobDetails.prototype.clearApplication = function() {
  return this.setApplication(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobDetails.prototype.hasApplication = function() {
  return jspb.Message.getField(this, 64) != null;
};


/**
 * optional Machine machine = 65;
 * @return {?proto.cloud.Machine}
 */
proto.cloud.JobDetails.prototype.getMachine = function() {
  return /** @type{?proto.cloud.Machine} */ (
    jspb.Message.getWrapperField(this, general_pb.Machine, 65));
};


/**
 * @param {?proto.cloud.Machine|undefined} value
 * @return {!proto.cloud.JobDetails} returns this
*/
proto.cloud.JobDetails.prototype.setMachine = function(value) {
  return jspb.Message.setWrapperField(this, 65, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobDetails} returns this
 */
proto.cloud.JobDetails.prototype.clearMachine = function() {
  return this.setMachine(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobDetails.prototype.hasMachine = function() {
  return jspb.Message.getField(this, 65) != null;
};


/**
 * optional string manifest_id = 66;
 * @return {string}
 */
proto.cloud.JobDetails.prototype.getManifestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 66, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobDetails} returns this
 */
proto.cloud.JobDetails.prototype.setManifestId = function(value) {
  return jspb.Message.setProto3StringField(this, 66, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobInfoIngest.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobInfoIngest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobInfoIngest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobInfoIngest.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    details: (f = msg.getDetails()) && proto.cloud.JobDetails.toObject(includeInstance, f),
    snapshot: (f = msg.getSnapshot()) && proto.cloud.JobSnapshot.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobInfoIngest}
 */
proto.cloud.JobInfoIngest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobInfoIngest;
  return proto.cloud.JobInfoIngest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobInfoIngest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobInfoIngest}
 */
proto.cloud.JobInfoIngest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = new proto.cloud.JobDetails;
      reader.readMessage(value,proto.cloud.JobDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    case 20:
      var value = new proto.cloud.JobSnapshot;
      reader.readMessage(value,proto.cloud.JobSnapshot.deserializeBinaryFromReader);
      msg.setSnapshot(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobInfoIngest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobInfoIngest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobInfoIngest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobInfoIngest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.cloud.JobDetails.serializeBinaryToWriter
    );
  }
  f = message.getSnapshot();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.cloud.JobSnapshot.serializeBinaryToWriter
    );
  }
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.cloud.JobInfoIngest.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobInfoIngest} returns this
 */
proto.cloud.JobInfoIngest.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional JobDetails details = 2;
 * @return {?proto.cloud.JobDetails}
 */
proto.cloud.JobInfoIngest.prototype.getDetails = function() {
  return /** @type{?proto.cloud.JobDetails} */ (
    jspb.Message.getWrapperField(this, proto.cloud.JobDetails, 2));
};


/**
 * @param {?proto.cloud.JobDetails|undefined} value
 * @return {!proto.cloud.JobInfoIngest} returns this
*/
proto.cloud.JobInfoIngest.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobInfoIngest} returns this
 */
proto.cloud.JobInfoIngest.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobInfoIngest.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional JobSnapshot snapshot = 20;
 * @return {?proto.cloud.JobSnapshot}
 */
proto.cloud.JobInfoIngest.prototype.getSnapshot = function() {
  return /** @type{?proto.cloud.JobSnapshot} */ (
    jspb.Message.getWrapperField(this, proto.cloud.JobSnapshot, 20));
};


/**
 * @param {?proto.cloud.JobSnapshot|undefined} value
 * @return {!proto.cloud.JobInfoIngest} returns this
*/
proto.cloud.JobInfoIngest.prototype.setSnapshot = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobInfoIngest} returns this
 */
proto.cloud.JobInfoIngest.prototype.clearSnapshot = function() {
  return this.setSnapshot(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobInfoIngest.prototype.hasSnapshot = function() {
  return jspb.Message.getField(this, 20) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.JobInfoQuery.repeatedFields_ = [100,105,130,108,110];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobInfoQuery.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobInfoQuery.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobInfoQuery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobInfoQuery.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    jobId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    name: jspb.Message.getFieldWithDefault(msg, 4, ""),
    jobType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    dateStarted: jspb.Message.getFieldWithDefault(msg, 6, ""),
    dateFinished: jspb.Message.getFieldWithDefault(msg, 7, ""),
    dateIngested: jspb.Message.getFieldWithDefault(msg, 8, ""),
    countFolders: jspb.Message.getFieldWithDefault(msg, 9, 0),
    countFiles: jspb.Message.getFieldWithDefault(msg, 10, 0),
    bytes: jspb.Message.getFieldWithDefault(msg, 11, 0),
    userCreatedId: jspb.Message.getFieldWithDefault(msg, 12, ""),
    aggregatePhase: jspb.Message.getFieldWithDefault(msg, 13, 0),
    aggregateStatus: jspb.Message.getFieldWithDefault(msg, 14, 0),
    application: (f = msg.getApplication()) && general_pb.Application.toObject(includeInstance, f),
    machine: (f = msg.getMachine()) && general_pb.Machine.toObject(includeInstance, f),
    keyEntitySize: jspb.Message.getFieldWithDefault(msg, 66, 0),
    keyEntityChecksum: jspb.Message.getFieldWithDefault(msg, 67, ""),
    expandedReportsList: jspb.Message.toObjectList(msg.getExpandedReportsList(),
    entity_pb.Entity.toObject, includeInstance),
    reportsWereExpanded: jspb.Message.getBooleanFieldWithDefault(msg, 101, false),
    expandedKeyEntity: (f = msg.getExpandedKeyEntity()) && entity_pb.Entity.toObject(includeInstance, f),
    keyEntityWasExpanded: jspb.Message.getBooleanFieldWithDefault(msg, 103, false),
    expandedJobFoldersMap: (f = msg.getExpandedJobFoldersMap()) ? f.toObject(includeInstance, proto.cloud.JobFolder.toObject) : [],
    expandedJobFolderRootIdsList: (f = jspb.Message.getRepeatedField(msg, 105)) == null ? undefined : f,
    jobFoldersWereExpanded: jspb.Message.getBooleanFieldWithDefault(msg, 106, false),
    expandedMediaDerivativesList: jspb.Message.toObjectList(msg.getExpandedMediaDerivativesList(),
    proto.cloud.MediaDerivative.toObject, includeInstance),
    mediaDerivativesWereExpanded: jspb.Message.getBooleanFieldWithDefault(msg, 131, false),
    expandedTagsList: jspb.Message.toObjectList(msg.getExpandedTagsList(),
    general_pb.Tag.toObject, includeInstance),
    tagsWereExpanded: jspb.Message.getBooleanFieldWithDefault(msg, 109, false),
    expandedVolumeMappingList: jspb.Message.toObjectList(msg.getExpandedVolumeMappingList(),
    drive_pb.VolumeFolder.toObject, includeInstance),
    volumeMappingWasExpanded: jspb.Message.getBooleanFieldWithDefault(msg, 111, false),
    notesWereExpanded: jspb.Message.getBooleanFieldWithDefault(msg, 120, false),
    rootTasks: (f = msg.getRootTasks()) && proto.cloud.JobTasks.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobInfoQuery}
 */
proto.cloud.JobInfoQuery.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobInfoQuery;
  return proto.cloud.JobInfoQuery.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobInfoQuery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobInfoQuery}
 */
proto.cloud.JobInfoQuery.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {!proto.cloud.JobType} */ (reader.readEnum());
      msg.setJobType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateStarted(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateFinished(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateIngested(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCountFolders(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCountFiles(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBytes(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserCreatedId(value);
      break;
    case 13:
      var value = /** @type {!proto.cloud.TaskPhase} */ (reader.readEnum());
      msg.setAggregatePhase(value);
      break;
    case 14:
      var value = /** @type {!proto.cloud.TaskStatus} */ (reader.readEnum());
      msg.setAggregateStatus(value);
      break;
    case 64:
      var value = new general_pb.Application;
      reader.readMessage(value,general_pb.Application.deserializeBinaryFromReader);
      msg.setApplication(value);
      break;
    case 65:
      var value = new general_pb.Machine;
      reader.readMessage(value,general_pb.Machine.deserializeBinaryFromReader);
      msg.setMachine(value);
      break;
    case 66:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setKeyEntitySize(value);
      break;
    case 67:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyEntityChecksum(value);
      break;
    case 100:
      var value = new entity_pb.Entity;
      reader.readMessage(value,entity_pb.Entity.deserializeBinaryFromReader);
      msg.addExpandedReports(value);
      break;
    case 101:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReportsWereExpanded(value);
      break;
    case 102:
      var value = new entity_pb.Entity;
      reader.readMessage(value,entity_pb.Entity.deserializeBinaryFromReader);
      msg.setExpandedKeyEntity(value);
      break;
    case 103:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setKeyEntityWasExpanded(value);
      break;
    case 104:
      var value = msg.getExpandedJobFoldersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readMessage, proto.cloud.JobFolder.deserializeBinaryFromReader, 0, new proto.cloud.JobFolder());
         });
      break;
    case 105:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setExpandedJobFolderRootIdsList(value);
      break;
    case 106:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setJobFoldersWereExpanded(value);
      break;
    case 130:
      var value = new proto.cloud.MediaDerivative;
      reader.readMessage(value,proto.cloud.MediaDerivative.deserializeBinaryFromReader);
      msg.addExpandedMediaDerivatives(value);
      break;
    case 131:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMediaDerivativesWereExpanded(value);
      break;
    case 108:
      var value = new general_pb.Tag;
      reader.readMessage(value,general_pb.Tag.deserializeBinaryFromReader);
      msg.addExpandedTags(value);
      break;
    case 109:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTagsWereExpanded(value);
      break;
    case 110:
      var value = new drive_pb.VolumeFolder;
      reader.readMessage(value,drive_pb.VolumeFolder.deserializeBinaryFromReader);
      msg.addExpandedVolumeMapping(value);
      break;
    case 111:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVolumeMappingWasExpanded(value);
      break;
    case 120:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNotesWereExpanded(value);
      break;
    case 150:
      var value = new proto.cloud.JobTasks;
      reader.readMessage(value,proto.cloud.JobTasks.deserializeBinaryFromReader);
      msg.setRootTasks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobInfoQuery.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobInfoQuery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobInfoQuery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobInfoQuery.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getJobType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getDateStarted();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDateFinished();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDateIngested();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCountFolders();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getCountFiles();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getBytes();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getUserCreatedId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAggregatePhase();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getAggregateStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getApplication();
  if (f != null) {
    writer.writeMessage(
      64,
      f,
      general_pb.Application.serializeBinaryToWriter
    );
  }
  f = message.getMachine();
  if (f != null) {
    writer.writeMessage(
      65,
      f,
      general_pb.Machine.serializeBinaryToWriter
    );
  }
  f = message.getKeyEntitySize();
  if (f !== 0) {
    writer.writeInt64(
      66,
      f
    );
  }
  f = message.getKeyEntityChecksum();
  if (f.length > 0) {
    writer.writeString(
      67,
      f
    );
  }
  f = message.getExpandedReportsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      100,
      f,
      entity_pb.Entity.serializeBinaryToWriter
    );
  }
  f = message.getReportsWereExpanded();
  if (f) {
    writer.writeBool(
      101,
      f
    );
  }
  f = message.getExpandedKeyEntity();
  if (f != null) {
    writer.writeMessage(
      102,
      f,
      entity_pb.Entity.serializeBinaryToWriter
    );
  }
  f = message.getKeyEntityWasExpanded();
  if (f) {
    writer.writeBool(
      103,
      f
    );
  }
  f = message.getExpandedJobFoldersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(104, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeMessage, proto.cloud.JobFolder.serializeBinaryToWriter);
  }
  f = message.getExpandedJobFolderRootIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      105,
      f
    );
  }
  f = message.getJobFoldersWereExpanded();
  if (f) {
    writer.writeBool(
      106,
      f
    );
  }
  f = message.getExpandedMediaDerivativesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      130,
      f,
      proto.cloud.MediaDerivative.serializeBinaryToWriter
    );
  }
  f = message.getMediaDerivativesWereExpanded();
  if (f) {
    writer.writeBool(
      131,
      f
    );
  }
  f = message.getExpandedTagsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      108,
      f,
      general_pb.Tag.serializeBinaryToWriter
    );
  }
  f = message.getTagsWereExpanded();
  if (f) {
    writer.writeBool(
      109,
      f
    );
  }
  f = message.getExpandedVolumeMappingList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      110,
      f,
      drive_pb.VolumeFolder.serializeBinaryToWriter
    );
  }
  f = message.getVolumeMappingWasExpanded();
  if (f) {
    writer.writeBool(
      111,
      f
    );
  }
  f = message.getNotesWereExpanded();
  if (f) {
    writer.writeBool(
      120,
      f
    );
  }
  f = message.getRootTasks();
  if (f != null) {
    writer.writeMessage(
      150,
      f,
      proto.cloud.JobTasks.serializeBinaryToWriter
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.cloud.JobInfoQuery.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.cloud.JobInfoQuery.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string job_id = 3;
 * @return {string}
 */
proto.cloud.JobInfoQuery.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.cloud.JobInfoQuery.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional JobType job_type = 5;
 * @return {!proto.cloud.JobType}
 */
proto.cloud.JobInfoQuery.prototype.getJobType = function() {
  return /** @type {!proto.cloud.JobType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.cloud.JobType} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setJobType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string date_started = 6;
 * @return {string}
 */
proto.cloud.JobInfoQuery.prototype.getDateStarted = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setDateStarted = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string date_finished = 7;
 * @return {string}
 */
proto.cloud.JobInfoQuery.prototype.getDateFinished = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setDateFinished = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string date_ingested = 8;
 * @return {string}
 */
proto.cloud.JobInfoQuery.prototype.getDateIngested = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setDateIngested = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 count_folders = 9;
 * @return {number}
 */
proto.cloud.JobInfoQuery.prototype.getCountFolders = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setCountFolders = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 count_files = 10;
 * @return {number}
 */
proto.cloud.JobInfoQuery.prototype.getCountFiles = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setCountFiles = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 bytes = 11;
 * @return {number}
 */
proto.cloud.JobInfoQuery.prototype.getBytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setBytes = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string user_created_id = 12;
 * @return {string}
 */
proto.cloud.JobInfoQuery.prototype.getUserCreatedId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setUserCreatedId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional TaskPhase aggregate_phase = 13;
 * @return {!proto.cloud.TaskPhase}
 */
proto.cloud.JobInfoQuery.prototype.getAggregatePhase = function() {
  return /** @type {!proto.cloud.TaskPhase} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.cloud.TaskPhase} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setAggregatePhase = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional TaskStatus aggregate_status = 14;
 * @return {!proto.cloud.TaskStatus}
 */
proto.cloud.JobInfoQuery.prototype.getAggregateStatus = function() {
  return /** @type {!proto.cloud.TaskStatus} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.cloud.TaskStatus} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setAggregateStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional Application application = 64;
 * @return {?proto.cloud.Application}
 */
proto.cloud.JobInfoQuery.prototype.getApplication = function() {
  return /** @type{?proto.cloud.Application} */ (
    jspb.Message.getWrapperField(this, general_pb.Application, 64));
};


/**
 * @param {?proto.cloud.Application|undefined} value
 * @return {!proto.cloud.JobInfoQuery} returns this
*/
proto.cloud.JobInfoQuery.prototype.setApplication = function(value) {
  return jspb.Message.setWrapperField(this, 64, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.clearApplication = function() {
  return this.setApplication(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobInfoQuery.prototype.hasApplication = function() {
  return jspb.Message.getField(this, 64) != null;
};


/**
 * optional Machine machine = 65;
 * @return {?proto.cloud.Machine}
 */
proto.cloud.JobInfoQuery.prototype.getMachine = function() {
  return /** @type{?proto.cloud.Machine} */ (
    jspb.Message.getWrapperField(this, general_pb.Machine, 65));
};


/**
 * @param {?proto.cloud.Machine|undefined} value
 * @return {!proto.cloud.JobInfoQuery} returns this
*/
proto.cloud.JobInfoQuery.prototype.setMachine = function(value) {
  return jspb.Message.setWrapperField(this, 65, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.clearMachine = function() {
  return this.setMachine(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobInfoQuery.prototype.hasMachine = function() {
  return jspb.Message.getField(this, 65) != null;
};


/**
 * optional int64 key_entity_size = 66;
 * @return {number}
 */
proto.cloud.JobInfoQuery.prototype.getKeyEntitySize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 66, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setKeyEntitySize = function(value) {
  return jspb.Message.setProto3IntField(this, 66, value);
};


/**
 * optional string key_entity_checksum = 67;
 * @return {string}
 */
proto.cloud.JobInfoQuery.prototype.getKeyEntityChecksum = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 67, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setKeyEntityChecksum = function(value) {
  return jspb.Message.setProto3StringField(this, 67, value);
};


/**
 * repeated Entity expanded_reports = 100;
 * @return {!Array<!proto.cloud.Entity>}
 */
proto.cloud.JobInfoQuery.prototype.getExpandedReportsList = function() {
  return /** @type{!Array<!proto.cloud.Entity>} */ (
    jspb.Message.getRepeatedWrapperField(this, entity_pb.Entity, 100));
};


/**
 * @param {!Array<!proto.cloud.Entity>} value
 * @return {!proto.cloud.JobInfoQuery} returns this
*/
proto.cloud.JobInfoQuery.prototype.setExpandedReportsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 100, value);
};


/**
 * @param {!proto.cloud.Entity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.Entity}
 */
proto.cloud.JobInfoQuery.prototype.addExpandedReports = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 100, opt_value, proto.cloud.Entity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.clearExpandedReportsList = function() {
  return this.setExpandedReportsList([]);
};


/**
 * optional bool reports_were_expanded = 101;
 * @return {boolean}
 */
proto.cloud.JobInfoQuery.prototype.getReportsWereExpanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 101, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setReportsWereExpanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 101, value);
};


/**
 * optional Entity expanded_key_entity = 102;
 * @return {?proto.cloud.Entity}
 */
proto.cloud.JobInfoQuery.prototype.getExpandedKeyEntity = function() {
  return /** @type{?proto.cloud.Entity} */ (
    jspb.Message.getWrapperField(this, entity_pb.Entity, 102));
};


/**
 * @param {?proto.cloud.Entity|undefined} value
 * @return {!proto.cloud.JobInfoQuery} returns this
*/
proto.cloud.JobInfoQuery.prototype.setExpandedKeyEntity = function(value) {
  return jspb.Message.setWrapperField(this, 102, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.clearExpandedKeyEntity = function() {
  return this.setExpandedKeyEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobInfoQuery.prototype.hasExpandedKeyEntity = function() {
  return jspb.Message.getField(this, 102) != null;
};


/**
 * optional bool key_entity_was_expanded = 103;
 * @return {boolean}
 */
proto.cloud.JobInfoQuery.prototype.getKeyEntityWasExpanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 103, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setKeyEntityWasExpanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 103, value);
};


/**
 * map<int64, JobFolder> expanded_job_folders = 104;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.cloud.JobFolder>}
 */
proto.cloud.JobInfoQuery.prototype.getExpandedJobFoldersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.cloud.JobFolder>} */ (
      jspb.Message.getMapField(this, 104, opt_noLazyCreate,
      proto.cloud.JobFolder));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.clearExpandedJobFoldersMap = function() {
  this.getExpandedJobFoldersMap().clear();
  return this;};


/**
 * repeated int64 expanded_job_folder_root_ids = 105;
 * @return {!Array<number>}
 */
proto.cloud.JobInfoQuery.prototype.getExpandedJobFolderRootIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 105));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setExpandedJobFolderRootIdsList = function(value) {
  return jspb.Message.setField(this, 105, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.addExpandedJobFolderRootIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 105, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.clearExpandedJobFolderRootIdsList = function() {
  return this.setExpandedJobFolderRootIdsList([]);
};


/**
 * optional bool job_folders_were_expanded = 106;
 * @return {boolean}
 */
proto.cloud.JobInfoQuery.prototype.getJobFoldersWereExpanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 106, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setJobFoldersWereExpanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 106, value);
};


/**
 * repeated MediaDerivative expanded_media_derivatives = 130;
 * @return {!Array<!proto.cloud.MediaDerivative>}
 */
proto.cloud.JobInfoQuery.prototype.getExpandedMediaDerivativesList = function() {
  return /** @type{!Array<!proto.cloud.MediaDerivative>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.MediaDerivative, 130));
};


/**
 * @param {!Array<!proto.cloud.MediaDerivative>} value
 * @return {!proto.cloud.JobInfoQuery} returns this
*/
proto.cloud.JobInfoQuery.prototype.setExpandedMediaDerivativesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 130, value);
};


/**
 * @param {!proto.cloud.MediaDerivative=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.MediaDerivative}
 */
proto.cloud.JobInfoQuery.prototype.addExpandedMediaDerivatives = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 130, opt_value, proto.cloud.MediaDerivative, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.clearExpandedMediaDerivativesList = function() {
  return this.setExpandedMediaDerivativesList([]);
};


/**
 * optional bool media_derivatives_were_expanded = 131;
 * @return {boolean}
 */
proto.cloud.JobInfoQuery.prototype.getMediaDerivativesWereExpanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 131, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setMediaDerivativesWereExpanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 131, value);
};


/**
 * repeated Tag expanded_tags = 108;
 * @return {!Array<!proto.cloud.Tag>}
 */
proto.cloud.JobInfoQuery.prototype.getExpandedTagsList = function() {
  return /** @type{!Array<!proto.cloud.Tag>} */ (
    jspb.Message.getRepeatedWrapperField(this, general_pb.Tag, 108));
};


/**
 * @param {!Array<!proto.cloud.Tag>} value
 * @return {!proto.cloud.JobInfoQuery} returns this
*/
proto.cloud.JobInfoQuery.prototype.setExpandedTagsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 108, value);
};


/**
 * @param {!proto.cloud.Tag=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.Tag}
 */
proto.cloud.JobInfoQuery.prototype.addExpandedTags = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 108, opt_value, proto.cloud.Tag, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.clearExpandedTagsList = function() {
  return this.setExpandedTagsList([]);
};


/**
 * optional bool tags_were_expanded = 109;
 * @return {boolean}
 */
proto.cloud.JobInfoQuery.prototype.getTagsWereExpanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 109, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setTagsWereExpanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 109, value);
};


/**
 * repeated VolumeFolder expanded_volume_mapping = 110;
 * @return {!Array<!proto.cloud.VolumeFolder>}
 */
proto.cloud.JobInfoQuery.prototype.getExpandedVolumeMappingList = function() {
  return /** @type{!Array<!proto.cloud.VolumeFolder>} */ (
    jspb.Message.getRepeatedWrapperField(this, drive_pb.VolumeFolder, 110));
};


/**
 * @param {!Array<!proto.cloud.VolumeFolder>} value
 * @return {!proto.cloud.JobInfoQuery} returns this
*/
proto.cloud.JobInfoQuery.prototype.setExpandedVolumeMappingList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 110, value);
};


/**
 * @param {!proto.cloud.VolumeFolder=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.VolumeFolder}
 */
proto.cloud.JobInfoQuery.prototype.addExpandedVolumeMapping = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 110, opt_value, proto.cloud.VolumeFolder, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.clearExpandedVolumeMappingList = function() {
  return this.setExpandedVolumeMappingList([]);
};


/**
 * optional bool volume_mapping_was_expanded = 111;
 * @return {boolean}
 */
proto.cloud.JobInfoQuery.prototype.getVolumeMappingWasExpanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 111, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setVolumeMappingWasExpanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 111, value);
};


/**
 * optional bool notes_were_expanded = 120;
 * @return {boolean}
 */
proto.cloud.JobInfoQuery.prototype.getNotesWereExpanded = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 120, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.setNotesWereExpanded = function(value) {
  return jspb.Message.setProto3BooleanField(this, 120, value);
};


/**
 * optional JobTasks root_tasks = 150;
 * @return {?proto.cloud.JobTasks}
 */
proto.cloud.JobInfoQuery.prototype.getRootTasks = function() {
  return /** @type{?proto.cloud.JobTasks} */ (
    jspb.Message.getWrapperField(this, proto.cloud.JobTasks, 150));
};


/**
 * @param {?proto.cloud.JobTasks|undefined} value
 * @return {!proto.cloud.JobInfoQuery} returns this
*/
proto.cloud.JobInfoQuery.prototype.setRootTasks = function(value) {
  return jspb.Message.setWrapperField(this, 150, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobInfoQuery} returns this
 */
proto.cloud.JobInfoQuery.prototype.clearRootTasks = function() {
  return this.setRootTasks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobInfoQuery.prototype.hasRootTasks = function() {
  return jspb.Message.getField(this, 150) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobInfoQueryExpansionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobInfoQueryExpansionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobInfoQueryExpansionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    shouldExpandReports: (f = msg.getShouldExpandReports()) && entity_pb.EntityInfoExpansionRequest.toObject(includeInstance, f),
    shouldExpandKeyEntity: (f = msg.getShouldExpandKeyEntity()) && entity_pb.EntityInfoExpansionRequest.toObject(includeInstance, f),
    shouldExpandJobFolders: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    shouldExpandTags: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    shouldExpandVolumeMapping: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    shouldExpandTasks: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    shouldExpandMediaDerivatives: jspb.Message.getBooleanFieldWithDefault(msg, 8, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobInfoQueryExpansionRequest}
 */
proto.cloud.JobInfoQueryExpansionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobInfoQueryExpansionRequest;
  return proto.cloud.JobInfoQueryExpansionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobInfoQueryExpansionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobInfoQueryExpansionRequest}
 */
proto.cloud.JobInfoQueryExpansionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new entity_pb.EntityInfoExpansionRequest;
      reader.readMessage(value,entity_pb.EntityInfoExpansionRequest.deserializeBinaryFromReader);
      msg.setShouldExpandReports(value);
      break;
    case 2:
      var value = new entity_pb.EntityInfoExpansionRequest;
      reader.readMessage(value,entity_pb.EntityInfoExpansionRequest.deserializeBinaryFromReader);
      msg.setShouldExpandKeyEntity(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldExpandJobFolders(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldExpandTags(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldExpandVolumeMapping(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldExpandTasks(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShouldExpandMediaDerivatives(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobInfoQueryExpansionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobInfoQueryExpansionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobInfoQueryExpansionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShouldExpandReports();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      entity_pb.EntityInfoExpansionRequest.serializeBinaryToWriter
    );
  }
  f = message.getShouldExpandKeyEntity();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      entity_pb.EntityInfoExpansionRequest.serializeBinaryToWriter
    );
  }
  f = message.getShouldExpandJobFolders();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getShouldExpandTags();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getShouldExpandVolumeMapping();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getShouldExpandTasks();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getShouldExpandMediaDerivatives();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
};


/**
 * optional EntityInfoExpansionRequest should_expand_reports = 1;
 * @return {?proto.cloud.EntityInfoExpansionRequest}
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.getShouldExpandReports = function() {
  return /** @type{?proto.cloud.EntityInfoExpansionRequest} */ (
    jspb.Message.getWrapperField(this, entity_pb.EntityInfoExpansionRequest, 1));
};


/**
 * @param {?proto.cloud.EntityInfoExpansionRequest|undefined} value
 * @return {!proto.cloud.JobInfoQueryExpansionRequest} returns this
*/
proto.cloud.JobInfoQueryExpansionRequest.prototype.setShouldExpandReports = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobInfoQueryExpansionRequest} returns this
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.clearShouldExpandReports = function() {
  return this.setShouldExpandReports(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.hasShouldExpandReports = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EntityInfoExpansionRequest should_expand_key_entity = 2;
 * @return {?proto.cloud.EntityInfoExpansionRequest}
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.getShouldExpandKeyEntity = function() {
  return /** @type{?proto.cloud.EntityInfoExpansionRequest} */ (
    jspb.Message.getWrapperField(this, entity_pb.EntityInfoExpansionRequest, 2));
};


/**
 * @param {?proto.cloud.EntityInfoExpansionRequest|undefined} value
 * @return {!proto.cloud.JobInfoQueryExpansionRequest} returns this
*/
proto.cloud.JobInfoQueryExpansionRequest.prototype.setShouldExpandKeyEntity = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobInfoQueryExpansionRequest} returns this
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.clearShouldExpandKeyEntity = function() {
  return this.setShouldExpandKeyEntity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.hasShouldExpandKeyEntity = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool should_expand_job_folders = 3;
 * @return {boolean}
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.getShouldExpandJobFolders = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.JobInfoQueryExpansionRequest} returns this
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.setShouldExpandJobFolders = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool should_expand_tags = 4;
 * @return {boolean}
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.getShouldExpandTags = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.JobInfoQueryExpansionRequest} returns this
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.setShouldExpandTags = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool should_expand_volume_mapping = 5;
 * @return {boolean}
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.getShouldExpandVolumeMapping = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.JobInfoQueryExpansionRequest} returns this
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.setShouldExpandVolumeMapping = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool should_expand_tasks = 7;
 * @return {boolean}
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.getShouldExpandTasks = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.JobInfoQueryExpansionRequest} returns this
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.setShouldExpandTasks = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool should_expand_media_derivatives = 8;
 * @return {boolean}
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.getShouldExpandMediaDerivatives = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.JobInfoQueryExpansionRequest} returns this
 */
proto.cloud.JobInfoQueryExpansionRequest.prototype.setShouldExpandMediaDerivatives = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobTasks.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobTasks.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobTasks} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobTasks.toObject = function(includeInstance, msg) {
  var f, obj = {
    copyTask: (f = msg.getCopyTask()) && task_pb.RootTask.toObject(includeInstance, f),
    verifyTask: (f = msg.getVerifyTask()) && task_pb.RootTask.toObject(includeInstance, f),
    uploadTask: (f = msg.getUploadTask()) && task_pb.RootTask.toObject(includeInstance, f),
    downloadTask: (f = msg.getDownloadTask()) && task_pb.RootTask.toObject(includeInstance, f),
    transcodeTask: (f = msg.getTranscodeTask()) && task_pb.RootTask.toObject(includeInstance, f),
    thumbnailTask: (f = msg.getThumbnailTask()) && task_pb.RootTask.toObject(includeInstance, f),
    metadataTask: (f = msg.getMetadataTask()) && task_pb.RootTask.toObject(includeInstance, f),
    compareTask: (f = msg.getCompareTask()) && task_pb.RootTask.toObject(includeInstance, f),
    reportTask: (f = msg.getReportTask()) && task_pb.RootTask.toObject(includeInstance, f),
    indexTask: (f = msg.getIndexTask()) && task_pb.RootTask.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobTasks}
 */
proto.cloud.JobTasks.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobTasks;
  return proto.cloud.JobTasks.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobTasks} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobTasks}
 */
proto.cloud.JobTasks.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 18:
      var value = new task_pb.RootTask;
      reader.readMessage(value,task_pb.RootTask.deserializeBinaryFromReader);
      msg.setCopyTask(value);
      break;
    case 19:
      var value = new task_pb.RootTask;
      reader.readMessage(value,task_pb.RootTask.deserializeBinaryFromReader);
      msg.setVerifyTask(value);
      break;
    case 20:
      var value = new task_pb.RootTask;
      reader.readMessage(value,task_pb.RootTask.deserializeBinaryFromReader);
      msg.setUploadTask(value);
      break;
    case 21:
      var value = new task_pb.RootTask;
      reader.readMessage(value,task_pb.RootTask.deserializeBinaryFromReader);
      msg.setDownloadTask(value);
      break;
    case 22:
      var value = new task_pb.RootTask;
      reader.readMessage(value,task_pb.RootTask.deserializeBinaryFromReader);
      msg.setTranscodeTask(value);
      break;
    case 23:
      var value = new task_pb.RootTask;
      reader.readMessage(value,task_pb.RootTask.deserializeBinaryFromReader);
      msg.setThumbnailTask(value);
      break;
    case 24:
      var value = new task_pb.RootTask;
      reader.readMessage(value,task_pb.RootTask.deserializeBinaryFromReader);
      msg.setMetadataTask(value);
      break;
    case 25:
      var value = new task_pb.RootTask;
      reader.readMessage(value,task_pb.RootTask.deserializeBinaryFromReader);
      msg.setCompareTask(value);
      break;
    case 26:
      var value = new task_pb.RootTask;
      reader.readMessage(value,task_pb.RootTask.deserializeBinaryFromReader);
      msg.setReportTask(value);
      break;
    case 27:
      var value = new task_pb.RootTask;
      reader.readMessage(value,task_pb.RootTask.deserializeBinaryFromReader);
      msg.setIndexTask(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobTasks.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobTasks.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobTasks} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobTasks.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCopyTask();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      task_pb.RootTask.serializeBinaryToWriter
    );
  }
  f = message.getVerifyTask();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      task_pb.RootTask.serializeBinaryToWriter
    );
  }
  f = message.getUploadTask();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      task_pb.RootTask.serializeBinaryToWriter
    );
  }
  f = message.getDownloadTask();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      task_pb.RootTask.serializeBinaryToWriter
    );
  }
  f = message.getTranscodeTask();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      task_pb.RootTask.serializeBinaryToWriter
    );
  }
  f = message.getThumbnailTask();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      task_pb.RootTask.serializeBinaryToWriter
    );
  }
  f = message.getMetadataTask();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      task_pb.RootTask.serializeBinaryToWriter
    );
  }
  f = message.getCompareTask();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      task_pb.RootTask.serializeBinaryToWriter
    );
  }
  f = message.getReportTask();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      task_pb.RootTask.serializeBinaryToWriter
    );
  }
  f = message.getIndexTask();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      task_pb.RootTask.serializeBinaryToWriter
    );
  }
};


/**
 * optional RootTask copy_task = 18;
 * @return {?proto.cloud.RootTask}
 */
proto.cloud.JobTasks.prototype.getCopyTask = function() {
  return /** @type{?proto.cloud.RootTask} */ (
    jspb.Message.getWrapperField(this, task_pb.RootTask, 18));
};


/**
 * @param {?proto.cloud.RootTask|undefined} value
 * @return {!proto.cloud.JobTasks} returns this
*/
proto.cloud.JobTasks.prototype.setCopyTask = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobTasks} returns this
 */
proto.cloud.JobTasks.prototype.clearCopyTask = function() {
  return this.setCopyTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobTasks.prototype.hasCopyTask = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional RootTask verify_task = 19;
 * @return {?proto.cloud.RootTask}
 */
proto.cloud.JobTasks.prototype.getVerifyTask = function() {
  return /** @type{?proto.cloud.RootTask} */ (
    jspb.Message.getWrapperField(this, task_pb.RootTask, 19));
};


/**
 * @param {?proto.cloud.RootTask|undefined} value
 * @return {!proto.cloud.JobTasks} returns this
*/
proto.cloud.JobTasks.prototype.setVerifyTask = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobTasks} returns this
 */
proto.cloud.JobTasks.prototype.clearVerifyTask = function() {
  return this.setVerifyTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobTasks.prototype.hasVerifyTask = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional RootTask upload_task = 20;
 * @return {?proto.cloud.RootTask}
 */
proto.cloud.JobTasks.prototype.getUploadTask = function() {
  return /** @type{?proto.cloud.RootTask} */ (
    jspb.Message.getWrapperField(this, task_pb.RootTask, 20));
};


/**
 * @param {?proto.cloud.RootTask|undefined} value
 * @return {!proto.cloud.JobTasks} returns this
*/
proto.cloud.JobTasks.prototype.setUploadTask = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobTasks} returns this
 */
proto.cloud.JobTasks.prototype.clearUploadTask = function() {
  return this.setUploadTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobTasks.prototype.hasUploadTask = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional RootTask download_task = 21;
 * @return {?proto.cloud.RootTask}
 */
proto.cloud.JobTasks.prototype.getDownloadTask = function() {
  return /** @type{?proto.cloud.RootTask} */ (
    jspb.Message.getWrapperField(this, task_pb.RootTask, 21));
};


/**
 * @param {?proto.cloud.RootTask|undefined} value
 * @return {!proto.cloud.JobTasks} returns this
*/
proto.cloud.JobTasks.prototype.setDownloadTask = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobTasks} returns this
 */
proto.cloud.JobTasks.prototype.clearDownloadTask = function() {
  return this.setDownloadTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobTasks.prototype.hasDownloadTask = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional RootTask transcode_task = 22;
 * @return {?proto.cloud.RootTask}
 */
proto.cloud.JobTasks.prototype.getTranscodeTask = function() {
  return /** @type{?proto.cloud.RootTask} */ (
    jspb.Message.getWrapperField(this, task_pb.RootTask, 22));
};


/**
 * @param {?proto.cloud.RootTask|undefined} value
 * @return {!proto.cloud.JobTasks} returns this
*/
proto.cloud.JobTasks.prototype.setTranscodeTask = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobTasks} returns this
 */
proto.cloud.JobTasks.prototype.clearTranscodeTask = function() {
  return this.setTranscodeTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobTasks.prototype.hasTranscodeTask = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional RootTask thumbnail_task = 23;
 * @return {?proto.cloud.RootTask}
 */
proto.cloud.JobTasks.prototype.getThumbnailTask = function() {
  return /** @type{?proto.cloud.RootTask} */ (
    jspb.Message.getWrapperField(this, task_pb.RootTask, 23));
};


/**
 * @param {?proto.cloud.RootTask|undefined} value
 * @return {!proto.cloud.JobTasks} returns this
*/
proto.cloud.JobTasks.prototype.setThumbnailTask = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobTasks} returns this
 */
proto.cloud.JobTasks.prototype.clearThumbnailTask = function() {
  return this.setThumbnailTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobTasks.prototype.hasThumbnailTask = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional RootTask metadata_task = 24;
 * @return {?proto.cloud.RootTask}
 */
proto.cloud.JobTasks.prototype.getMetadataTask = function() {
  return /** @type{?proto.cloud.RootTask} */ (
    jspb.Message.getWrapperField(this, task_pb.RootTask, 24));
};


/**
 * @param {?proto.cloud.RootTask|undefined} value
 * @return {!proto.cloud.JobTasks} returns this
*/
proto.cloud.JobTasks.prototype.setMetadataTask = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobTasks} returns this
 */
proto.cloud.JobTasks.prototype.clearMetadataTask = function() {
  return this.setMetadataTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobTasks.prototype.hasMetadataTask = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional RootTask compare_task = 25;
 * @return {?proto.cloud.RootTask}
 */
proto.cloud.JobTasks.prototype.getCompareTask = function() {
  return /** @type{?proto.cloud.RootTask} */ (
    jspb.Message.getWrapperField(this, task_pb.RootTask, 25));
};


/**
 * @param {?proto.cloud.RootTask|undefined} value
 * @return {!proto.cloud.JobTasks} returns this
*/
proto.cloud.JobTasks.prototype.setCompareTask = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobTasks} returns this
 */
proto.cloud.JobTasks.prototype.clearCompareTask = function() {
  return this.setCompareTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobTasks.prototype.hasCompareTask = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional RootTask report_task = 26;
 * @return {?proto.cloud.RootTask}
 */
proto.cloud.JobTasks.prototype.getReportTask = function() {
  return /** @type{?proto.cloud.RootTask} */ (
    jspb.Message.getWrapperField(this, task_pb.RootTask, 26));
};


/**
 * @param {?proto.cloud.RootTask|undefined} value
 * @return {!proto.cloud.JobTasks} returns this
*/
proto.cloud.JobTasks.prototype.setReportTask = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobTasks} returns this
 */
proto.cloud.JobTasks.prototype.clearReportTask = function() {
  return this.setReportTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobTasks.prototype.hasReportTask = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional RootTask index_task = 27;
 * @return {?proto.cloud.RootTask}
 */
proto.cloud.JobTasks.prototype.getIndexTask = function() {
  return /** @type{?proto.cloud.RootTask} */ (
    jspb.Message.getWrapperField(this, task_pb.RootTask, 27));
};


/**
 * @param {?proto.cloud.RootTask|undefined} value
 * @return {!proto.cloud.JobTasks} returns this
*/
proto.cloud.JobTasks.prototype.setIndexTask = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobTasks} returns this
 */
proto.cloud.JobTasks.prototype.clearIndexTask = function() {
  return this.setIndexTask(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobTasks.prototype.hasIndexTask = function() {
  return jspb.Message.getField(this, 27) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobSnapshot.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobSnapshot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobSnapshot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobSnapshot.toObject = function(includeInstance, msg) {
  var f, obj = {
    snapTimestamp: jspb.Message.getFieldWithDefault(msg, 2, ""),
    secondsRemaining: jspb.Message.getFieldWithDefault(msg, 4, 0),
    aggregateTaskPhase: jspb.Message.getFieldWithDefault(msg, 5, 0),
    aggregateTaskStatus: jspb.Message.getFieldWithDefault(msg, 6, 0),
    rootTasks: (f = msg.getRootTasks()) && proto.cloud.JobTasks.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobSnapshot}
 */
proto.cloud.JobSnapshot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobSnapshot;
  return proto.cloud.JobSnapshot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobSnapshot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobSnapshot}
 */
proto.cloud.JobSnapshot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSnapTimestamp(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSecondsRemaining(value);
      break;
    case 5:
      var value = /** @type {!proto.cloud.TaskPhase} */ (reader.readEnum());
      msg.setAggregateTaskPhase(value);
      break;
    case 6:
      var value = /** @type {!proto.cloud.TaskStatus} */ (reader.readEnum());
      msg.setAggregateTaskStatus(value);
      break;
    case 7:
      var value = new proto.cloud.JobTasks;
      reader.readMessage(value,proto.cloud.JobTasks.deserializeBinaryFromReader);
      msg.setRootTasks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobSnapshot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobSnapshot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobSnapshot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobSnapshot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSnapTimestamp();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSecondsRemaining();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAggregateTaskPhase();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getAggregateTaskStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getRootTasks();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.cloud.JobTasks.serializeBinaryToWriter
    );
  }
};


/**
 * optional string snap_timestamp = 2;
 * @return {string}
 */
proto.cloud.JobSnapshot.prototype.getSnapTimestamp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobSnapshot} returns this
 */
proto.cloud.JobSnapshot.prototype.setSnapTimestamp = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 seconds_remaining = 4;
 * @return {number}
 */
proto.cloud.JobSnapshot.prototype.getSecondsRemaining = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.JobSnapshot} returns this
 */
proto.cloud.JobSnapshot.prototype.setSecondsRemaining = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional TaskPhase aggregate_task_phase = 5;
 * @return {!proto.cloud.TaskPhase}
 */
proto.cloud.JobSnapshot.prototype.getAggregateTaskPhase = function() {
  return /** @type {!proto.cloud.TaskPhase} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.cloud.TaskPhase} value
 * @return {!proto.cloud.JobSnapshot} returns this
 */
proto.cloud.JobSnapshot.prototype.setAggregateTaskPhase = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional TaskStatus aggregate_task_status = 6;
 * @return {!proto.cloud.TaskStatus}
 */
proto.cloud.JobSnapshot.prototype.getAggregateTaskStatus = function() {
  return /** @type {!proto.cloud.TaskStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.cloud.TaskStatus} value
 * @return {!proto.cloud.JobSnapshot} returns this
 */
proto.cloud.JobSnapshot.prototype.setAggregateTaskStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional JobTasks root_tasks = 7;
 * @return {?proto.cloud.JobTasks}
 */
proto.cloud.JobSnapshot.prototype.getRootTasks = function() {
  return /** @type{?proto.cloud.JobTasks} */ (
    jspb.Message.getWrapperField(this, proto.cloud.JobTasks, 7));
};


/**
 * @param {?proto.cloud.JobTasks|undefined} value
 * @return {!proto.cloud.JobSnapshot} returns this
*/
proto.cloud.JobSnapshot.prototype.setRootTasks = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobSnapshot} returns this
 */
proto.cloud.JobSnapshot.prototype.clearRootTasks = function() {
  return this.setRootTasks(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobSnapshot.prototype.hasRootTasks = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.JobNode.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobNode.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobNode.toObject = function(includeInstance, msg) {
  var f, obj = {
    nodeId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    details: (f = msg.getDetails()) && general_pb.FileInfo.toObject(includeInstance, f),
    errorsMap: (f = msg.getErrorsMap()) ? f.toObject(includeInstance, proto.cloud.AppError.toObject) : [],
    trackedDifferencesMap: (f = msg.getTrackedDifferencesMap()) ? f.toObject(includeInstance, proto.cloud.FileInfo.toObject) : [],
    fileSystemMapMap: (f = msg.getFileSystemMapMap()) ? f.toObject(includeInstance, proto.cloud.JobNode.Destinations.toObject) : [],
    matchingNodeIdsList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobNode}
 */
proto.cloud.JobNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobNode;
  return proto.cloud.JobNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobNode}
 */
proto.cloud.JobNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setNodeId(value);
      break;
    case 2:
      var value = new general_pb.FileInfo;
      reader.readMessage(value,general_pb.FileInfo.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    case 7:
      var value = msg.getErrorsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readMessage, proto.cloud.AppError.deserializeBinaryFromReader, 0, new proto.cloud.AppError());
         });
      break;
    case 8:
      var value = msg.getTrackedDifferencesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readMessage, proto.cloud.FileInfo.deserializeBinaryFromReader, 0, new proto.cloud.FileInfo());
         });
      break;
    case 9:
      var value = msg.getFileSystemMapMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readMessage, proto.cloud.JobNode.Destinations.deserializeBinaryFromReader, 0, new proto.cloud.JobNode.Destinations());
         });
      break;
    case 11:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setMatchingNodeIdsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNodeId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      general_pb.FileInfo.serializeBinaryToWriter
    );
  }
  f = message.getErrorsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeMessage, proto.cloud.AppError.serializeBinaryToWriter);
  }
  f = message.getTrackedDifferencesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(8, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeMessage, proto.cloud.FileInfo.serializeBinaryToWriter);
  }
  f = message.getFileSystemMapMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(9, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeMessage, proto.cloud.JobNode.Destinations.serializeBinaryToWriter);
  }
  f = message.getMatchingNodeIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      11,
      f
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.JobNode.Destinations.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobNode.Destinations.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobNode.Destinations.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobNode.Destinations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobNode.Destinations.toObject = function(includeInstance, msg) {
  var f, obj = {
    destinationsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobNode.Destinations}
 */
proto.cloud.JobNode.Destinations.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobNode.Destinations;
  return proto.cloud.JobNode.Destinations.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobNode.Destinations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobNode.Destinations}
 */
proto.cloud.JobNode.Destinations.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array<number>} */ (reader.readPackedInt64());
      msg.setDestinationsList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobNode.Destinations.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobNode.Destinations.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobNode.Destinations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobNode.Destinations.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDestinationsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      1,
      f
    );
  }
};


/**
 * repeated int64 destinations = 1;
 * @return {!Array<number>}
 */
proto.cloud.JobNode.Destinations.prototype.getDestinationsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.cloud.JobNode.Destinations} returns this
 */
proto.cloud.JobNode.Destinations.prototype.setDestinationsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.cloud.JobNode.Destinations} returns this
 */
proto.cloud.JobNode.Destinations.prototype.addDestinations = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.JobNode.Destinations} returns this
 */
proto.cloud.JobNode.Destinations.prototype.clearDestinationsList = function() {
  return this.setDestinationsList([]);
};


/**
 * optional int64 node_id = 1;
 * @return {number}
 */
proto.cloud.JobNode.prototype.getNodeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.JobNode} returns this
 */
proto.cloud.JobNode.prototype.setNodeId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional FileInfo details = 2;
 * @return {?proto.cloud.FileInfo}
 */
proto.cloud.JobNode.prototype.getDetails = function() {
  return /** @type{?proto.cloud.FileInfo} */ (
    jspb.Message.getWrapperField(this, general_pb.FileInfo, 2));
};


/**
 * @param {?proto.cloud.FileInfo|undefined} value
 * @return {!proto.cloud.JobNode} returns this
*/
proto.cloud.JobNode.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobNode} returns this
 */
proto.cloud.JobNode.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobNode.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * map<int64, AppError> errors = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.cloud.AppError>}
 */
proto.cloud.JobNode.prototype.getErrorsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.cloud.AppError>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      proto.cloud.AppError));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.cloud.JobNode} returns this
 */
proto.cloud.JobNode.prototype.clearErrorsMap = function() {
  this.getErrorsMap().clear();
  return this;};


/**
 * map<int64, FileInfo> tracked_differences = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.cloud.FileInfo>}
 */
proto.cloud.JobNode.prototype.getTrackedDifferencesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.cloud.FileInfo>} */ (
      jspb.Message.getMapField(this, 8, opt_noLazyCreate,
      proto.cloud.FileInfo));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.cloud.JobNode} returns this
 */
proto.cloud.JobNode.prototype.clearTrackedDifferencesMap = function() {
  this.getTrackedDifferencesMap().clear();
  return this;};


/**
 * map<int64, Destinations> file_system_map = 9;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,!proto.cloud.JobNode.Destinations>}
 */
proto.cloud.JobNode.prototype.getFileSystemMapMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,!proto.cloud.JobNode.Destinations>} */ (
      jspb.Message.getMapField(this, 9, opt_noLazyCreate,
      proto.cloud.JobNode.Destinations));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.cloud.JobNode} returns this
 */
proto.cloud.JobNode.prototype.clearFileSystemMapMap = function() {
  this.getFileSystemMapMap().clear();
  return this;};


/**
 * repeated int64 matching_node_ids = 11;
 * @return {!Array<number>}
 */
proto.cloud.JobNode.prototype.getMatchingNodeIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.cloud.JobNode} returns this
 */
proto.cloud.JobNode.prototype.setMatchingNodeIdsList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.cloud.JobNode} returns this
 */
proto.cloud.JobNode.prototype.addMatchingNodeIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.JobNode} returns this
 */
proto.cloud.JobNode.prototype.clearMatchingNodeIdsList = function() {
  return this.setMatchingNodeIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobFolder.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobFolder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobFolder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobFolder.toObject = function(includeInstance, msg) {
  var f, obj = {
    jobId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    type: jspb.Message.getFieldWithDefault(msg, 2, 0),
    info: (f = msg.getInfo()) && proto.cloud.JobNode.toObject(includeInstance, f),
    childDirs: (f = msg.getChildDirs()) && proto.cloud.JobFolder.DirectoryChildren.toObject(includeInstance, f),
    childFiles: (f = msg.getChildFiles()) && proto.cloud.JobFolder.FileChildren.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobFolder}
 */
proto.cloud.JobFolder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobFolder;
  return proto.cloud.JobFolder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobFolder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobFolder}
 */
proto.cloud.JobFolder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJobId(value);
      break;
    case 2:
      var value = /** @type {!proto.cloud.FolderType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 7:
      var value = new proto.cloud.JobNode;
      reader.readMessage(value,proto.cloud.JobNode.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 8:
      var value = new proto.cloud.JobFolder.DirectoryChildren;
      reader.readMessage(value,proto.cloud.JobFolder.DirectoryChildren.deserializeBinaryFromReader);
      msg.setChildDirs(value);
      break;
    case 9:
      var value = new proto.cloud.JobFolder.FileChildren;
      reader.readMessage(value,proto.cloud.JobFolder.FileChildren.deserializeBinaryFromReader);
      msg.setChildFiles(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobFolder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobFolder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobFolder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobFolder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJobId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.cloud.JobNode.serializeBinaryToWriter
    );
  }
  f = message.getChildDirs();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.cloud.JobFolder.DirectoryChildren.serializeBinaryToWriter
    );
  }
  f = message.getChildFiles();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.cloud.JobFolder.FileChildren.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobFolder.DirectoryChildren.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobFolder.DirectoryChildren.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobFolder.DirectoryChildren} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobFolder.DirectoryChildren.toObject = function(includeInstance, msg) {
  var f, obj = {
    childDirStartNodeId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    childDirEndNodeId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobFolder.DirectoryChildren}
 */
proto.cloud.JobFolder.DirectoryChildren.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobFolder.DirectoryChildren;
  return proto.cloud.JobFolder.DirectoryChildren.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobFolder.DirectoryChildren} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobFolder.DirectoryChildren}
 */
proto.cloud.JobFolder.DirectoryChildren.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChildDirStartNodeId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setChildDirEndNodeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobFolder.DirectoryChildren.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobFolder.DirectoryChildren.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobFolder.DirectoryChildren} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobFolder.DirectoryChildren.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChildDirStartNodeId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getChildDirEndNodeId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 child_dir_start_node_id = 1;
 * @return {number}
 */
proto.cloud.JobFolder.DirectoryChildren.prototype.getChildDirStartNodeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.JobFolder.DirectoryChildren} returns this
 */
proto.cloud.JobFolder.DirectoryChildren.prototype.setChildDirStartNodeId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 child_dir_end_node_id = 2;
 * @return {number}
 */
proto.cloud.JobFolder.DirectoryChildren.prototype.getChildDirEndNodeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.JobFolder.DirectoryChildren} returns this
 */
proto.cloud.JobFolder.DirectoryChildren.prototype.setChildDirEndNodeId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.JobFolder.FileChildren.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobFolder.FileChildren.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobFolder.FileChildren.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobFolder.FileChildren} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobFolder.FileChildren.toObject = function(includeInstance, msg) {
  var f, obj = {
    filesList: jspb.Message.toObjectList(msg.getFilesList(),
    proto.cloud.JobNode.toObject, includeInstance),
    containsSequence: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobFolder.FileChildren}
 */
proto.cloud.JobFolder.FileChildren.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobFolder.FileChildren;
  return proto.cloud.JobFolder.FileChildren.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobFolder.FileChildren} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobFolder.FileChildren}
 */
proto.cloud.JobFolder.FileChildren.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cloud.JobNode;
      reader.readMessage(value,proto.cloud.JobNode.deserializeBinaryFromReader);
      msg.addFiles(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setContainsSequence(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobFolder.FileChildren.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobFolder.FileChildren.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobFolder.FileChildren} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobFolder.FileChildren.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.cloud.JobNode.serializeBinaryToWriter
    );
  }
  f = message.getContainsSequence();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * repeated JobNode files = 1;
 * @return {!Array<!proto.cloud.JobNode>}
 */
proto.cloud.JobFolder.FileChildren.prototype.getFilesList = function() {
  return /** @type{!Array<!proto.cloud.JobNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.JobNode, 1));
};


/**
 * @param {!Array<!proto.cloud.JobNode>} value
 * @return {!proto.cloud.JobFolder.FileChildren} returns this
*/
proto.cloud.JobFolder.FileChildren.prototype.setFilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.cloud.JobNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.JobNode}
 */
proto.cloud.JobFolder.FileChildren.prototype.addFiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.cloud.JobNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.JobFolder.FileChildren} returns this
 */
proto.cloud.JobFolder.FileChildren.prototype.clearFilesList = function() {
  return this.setFilesList([]);
};


/**
 * optional bool contains_sequence = 2;
 * @return {boolean}
 */
proto.cloud.JobFolder.FileChildren.prototype.getContainsSequence = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.cloud.JobFolder.FileChildren} returns this
 */
proto.cloud.JobFolder.FileChildren.prototype.setContainsSequence = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string job_id = 1;
 * @return {string}
 */
proto.cloud.JobFolder.prototype.getJobId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobFolder} returns this
 */
proto.cloud.JobFolder.prototype.setJobId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional FolderType type = 2;
 * @return {!proto.cloud.FolderType}
 */
proto.cloud.JobFolder.prototype.getType = function() {
  return /** @type {!proto.cloud.FolderType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.cloud.FolderType} value
 * @return {!proto.cloud.JobFolder} returns this
 */
proto.cloud.JobFolder.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional JobNode info = 7;
 * @return {?proto.cloud.JobNode}
 */
proto.cloud.JobFolder.prototype.getInfo = function() {
  return /** @type{?proto.cloud.JobNode} */ (
    jspb.Message.getWrapperField(this, proto.cloud.JobNode, 7));
};


/**
 * @param {?proto.cloud.JobNode|undefined} value
 * @return {!proto.cloud.JobFolder} returns this
*/
proto.cloud.JobFolder.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobFolder} returns this
 */
proto.cloud.JobFolder.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobFolder.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional DirectoryChildren child_dirs = 8;
 * @return {?proto.cloud.JobFolder.DirectoryChildren}
 */
proto.cloud.JobFolder.prototype.getChildDirs = function() {
  return /** @type{?proto.cloud.JobFolder.DirectoryChildren} */ (
    jspb.Message.getWrapperField(this, proto.cloud.JobFolder.DirectoryChildren, 8));
};


/**
 * @param {?proto.cloud.JobFolder.DirectoryChildren|undefined} value
 * @return {!proto.cloud.JobFolder} returns this
*/
proto.cloud.JobFolder.prototype.setChildDirs = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobFolder} returns this
 */
proto.cloud.JobFolder.prototype.clearChildDirs = function() {
  return this.setChildDirs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobFolder.prototype.hasChildDirs = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional FileChildren child_files = 9;
 * @return {?proto.cloud.JobFolder.FileChildren}
 */
proto.cloud.JobFolder.prototype.getChildFiles = function() {
  return /** @type{?proto.cloud.JobFolder.FileChildren} */ (
    jspb.Message.getWrapperField(this, proto.cloud.JobFolder.FileChildren, 9));
};


/**
 * @param {?proto.cloud.JobFolder.FileChildren|undefined} value
 * @return {!proto.cloud.JobFolder} returns this
*/
proto.cloud.JobFolder.prototype.setChildFiles = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobFolder} returns this
 */
proto.cloud.JobFolder.prototype.clearChildFiles = function() {
  return this.setChildFiles(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobFolder.prototype.hasChildFiles = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobReport.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    node: (f = msg.getNode()) && proto.cloud.JobNode.toObject(includeInstance, f),
    locations: (f = msg.getLocations()) && proto.cloud.JobItemLocations.toObject(includeInstance, f),
    reportType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobReport}
 */
proto.cloud.JobReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobReport;
  return proto.cloud.JobReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobReport}
 */
proto.cloud.JobReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cloud.JobNode;
      reader.readMessage(value,proto.cloud.JobNode.deserializeBinaryFromReader);
      msg.setNode(value);
      break;
    case 2:
      var value = new proto.cloud.JobItemLocations;
      reader.readMessage(value,proto.cloud.JobItemLocations.deserializeBinaryFromReader);
      msg.setLocations(value);
      break;
    case 3:
      var value = /** @type {!proto.cloud.JobReportType} */ (reader.readEnum());
      msg.setReportType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNode();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.cloud.JobNode.serializeBinaryToWriter
    );
  }
  f = message.getLocations();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.cloud.JobItemLocations.serializeBinaryToWriter
    );
  }
  f = message.getReportType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional JobNode node = 1;
 * @return {?proto.cloud.JobNode}
 */
proto.cloud.JobReport.prototype.getNode = function() {
  return /** @type{?proto.cloud.JobNode} */ (
    jspb.Message.getWrapperField(this, proto.cloud.JobNode, 1));
};


/**
 * @param {?proto.cloud.JobNode|undefined} value
 * @return {!proto.cloud.JobReport} returns this
*/
proto.cloud.JobReport.prototype.setNode = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobReport} returns this
 */
proto.cloud.JobReport.prototype.clearNode = function() {
  return this.setNode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobReport.prototype.hasNode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional JobItemLocations locations = 2;
 * @return {?proto.cloud.JobItemLocations}
 */
proto.cloud.JobReport.prototype.getLocations = function() {
  return /** @type{?proto.cloud.JobItemLocations} */ (
    jspb.Message.getWrapperField(this, proto.cloud.JobItemLocations, 2));
};


/**
 * @param {?proto.cloud.JobItemLocations|undefined} value
 * @return {!proto.cloud.JobReport} returns this
*/
proto.cloud.JobReport.prototype.setLocations = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobReport} returns this
 */
proto.cloud.JobReport.prototype.clearLocations = function() {
  return this.setLocations(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobReport.prototype.hasLocations = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional JobReportType report_type = 3;
 * @return {!proto.cloud.JobReportType}
 */
proto.cloud.JobReport.prototype.getReportType = function() {
  return /** @type {!proto.cloud.JobReportType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.cloud.JobReportType} value
 * @return {!proto.cloud.JobReport} returns this
 */
proto.cloud.JobReport.prototype.setReportType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.MediaDerivative.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.MediaDerivative.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.MediaDerivative.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.MediaDerivative} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.MediaDerivative.toObject = function(includeInstance, msg) {
  var f, obj = {
    output: (f = msg.getOutput()) && general_pb.FileInfo.toObject(includeInstance, f),
    sourcesList: jspb.Message.toObjectList(msg.getSourcesList(),
    proto.cloud.MediaSource.toObject, includeInstance),
    entityClass: jspb.Message.getFieldWithDefault(msg, 3, 0),
    subseries: jspb.Message.getFieldWithDefault(msg, 4, 0),
    locations: (f = msg.getLocations()) && proto.cloud.JobItemLocations.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.MediaDerivative}
 */
proto.cloud.MediaDerivative.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.MediaDerivative;
  return proto.cloud.MediaDerivative.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.MediaDerivative} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.MediaDerivative}
 */
proto.cloud.MediaDerivative.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new general_pb.FileInfo;
      reader.readMessage(value,general_pb.FileInfo.deserializeBinaryFromReader);
      msg.setOutput(value);
      break;
    case 2:
      var value = new proto.cloud.MediaSource;
      reader.readMessage(value,proto.cloud.MediaSource.deserializeBinaryFromReader);
      msg.addSources(value);
      break;
    case 3:
      var value = /** @type {!proto.cloud.EntityClass} */ (reader.readEnum());
      msg.setEntityClass(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubseries(value);
      break;
    case 5:
      var value = new proto.cloud.JobItemLocations;
      reader.readMessage(value,proto.cloud.JobItemLocations.deserializeBinaryFromReader);
      msg.setLocations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.MediaDerivative.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.MediaDerivative.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.MediaDerivative} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.MediaDerivative.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOutput();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      general_pb.FileInfo.serializeBinaryToWriter
    );
  }
  f = message.getSourcesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.cloud.MediaSource.serializeBinaryToWriter
    );
  }
  f = message.getEntityClass();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSubseries();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getLocations();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.cloud.JobItemLocations.serializeBinaryToWriter
    );
  }
};


/**
 * optional FileInfo output = 1;
 * @return {?proto.cloud.FileInfo}
 */
proto.cloud.MediaDerivative.prototype.getOutput = function() {
  return /** @type{?proto.cloud.FileInfo} */ (
    jspb.Message.getWrapperField(this, general_pb.FileInfo, 1));
};


/**
 * @param {?proto.cloud.FileInfo|undefined} value
 * @return {!proto.cloud.MediaDerivative} returns this
*/
proto.cloud.MediaDerivative.prototype.setOutput = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.MediaDerivative} returns this
 */
proto.cloud.MediaDerivative.prototype.clearOutput = function() {
  return this.setOutput(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.MediaDerivative.prototype.hasOutput = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated MediaSource sources = 2;
 * @return {!Array<!proto.cloud.MediaSource>}
 */
proto.cloud.MediaDerivative.prototype.getSourcesList = function() {
  return /** @type{!Array<!proto.cloud.MediaSource>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.MediaSource, 2));
};


/**
 * @param {!Array<!proto.cloud.MediaSource>} value
 * @return {!proto.cloud.MediaDerivative} returns this
*/
proto.cloud.MediaDerivative.prototype.setSourcesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.cloud.MediaSource=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.MediaSource}
 */
proto.cloud.MediaDerivative.prototype.addSources = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.cloud.MediaSource, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.MediaDerivative} returns this
 */
proto.cloud.MediaDerivative.prototype.clearSourcesList = function() {
  return this.setSourcesList([]);
};


/**
 * optional EntityClass entity_class = 3;
 * @return {!proto.cloud.EntityClass}
 */
proto.cloud.MediaDerivative.prototype.getEntityClass = function() {
  return /** @type {!proto.cloud.EntityClass} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.cloud.EntityClass} value
 * @return {!proto.cloud.MediaDerivative} returns this
 */
proto.cloud.MediaDerivative.prototype.setEntityClass = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 subseries = 4;
 * @return {number}
 */
proto.cloud.MediaDerivative.prototype.getSubseries = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.cloud.MediaDerivative} returns this
 */
proto.cloud.MediaDerivative.prototype.setSubseries = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional JobItemLocations locations = 5;
 * @return {?proto.cloud.JobItemLocations}
 */
proto.cloud.MediaDerivative.prototype.getLocations = function() {
  return /** @type{?proto.cloud.JobItemLocations} */ (
    jspb.Message.getWrapperField(this, proto.cloud.JobItemLocations, 5));
};


/**
 * @param {?proto.cloud.JobItemLocations|undefined} value
 * @return {!proto.cloud.MediaDerivative} returns this
*/
proto.cloud.MediaDerivative.prototype.setLocations = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.MediaDerivative} returns this
 */
proto.cloud.MediaDerivative.prototype.clearLocations = function() {
  return this.setLocations(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.MediaDerivative.prototype.hasLocations = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.MediaSource.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.MediaSource.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.MediaSource} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.MediaSource.toObject = function(includeInstance, msg) {
  var f, obj = {
    item: (f = msg.getItem()) && general_pb.FileInfo.toObject(includeInstance, f),
    locations: (f = msg.getLocations()) && proto.cloud.JobItemLocations.toObject(includeInstance, f),
    derivativeType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.MediaSource}
 */
proto.cloud.MediaSource.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.MediaSource;
  return proto.cloud.MediaSource.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.MediaSource} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.MediaSource}
 */
proto.cloud.MediaSource.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new general_pb.FileInfo;
      reader.readMessage(value,general_pb.FileInfo.deserializeBinaryFromReader);
      msg.setItem(value);
      break;
    case 2:
      var value = new proto.cloud.JobItemLocations;
      reader.readMessage(value,proto.cloud.JobItemLocations.deserializeBinaryFromReader);
      msg.setLocations(value);
      break;
    case 3:
      var value = /** @type {!proto.cloud.EntityDerivativeType} */ (reader.readEnum());
      msg.setDerivativeType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.MediaSource.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.MediaSource.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.MediaSource} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.MediaSource.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItem();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      general_pb.FileInfo.serializeBinaryToWriter
    );
  }
  f = message.getLocations();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.cloud.JobItemLocations.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional FileInfo item = 1;
 * @return {?proto.cloud.FileInfo}
 */
proto.cloud.MediaSource.prototype.getItem = function() {
  return /** @type{?proto.cloud.FileInfo} */ (
    jspb.Message.getWrapperField(this, general_pb.FileInfo, 1));
};


/**
 * @param {?proto.cloud.FileInfo|undefined} value
 * @return {!proto.cloud.MediaSource} returns this
*/
proto.cloud.MediaSource.prototype.setItem = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.MediaSource} returns this
 */
proto.cloud.MediaSource.prototype.clearItem = function() {
  return this.setItem(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.MediaSource.prototype.hasItem = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional JobItemLocations locations = 2;
 * @return {?proto.cloud.JobItemLocations}
 */
proto.cloud.MediaSource.prototype.getLocations = function() {
  return /** @type{?proto.cloud.JobItemLocations} */ (
    jspb.Message.getWrapperField(this, proto.cloud.JobItemLocations, 2));
};


/**
 * @param {?proto.cloud.JobItemLocations|undefined} value
 * @return {!proto.cloud.MediaSource} returns this
*/
proto.cloud.MediaSource.prototype.setLocations = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.MediaSource} returns this
 */
proto.cloud.MediaSource.prototype.clearLocations = function() {
  return this.setLocations(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.MediaSource.prototype.hasLocations = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional EntityDerivativeType derivative_type = 3;
 * @return {!proto.cloud.EntityDerivativeType}
 */
proto.cloud.MediaSource.prototype.getDerivativeType = function() {
  return /** @type {!proto.cloud.EntityDerivativeType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.cloud.EntityDerivativeType} value
 * @return {!proto.cloud.MediaSource} returns this
 */
proto.cloud.MediaSource.prototype.setDerivativeType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.cloud.JobItemLocations.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobItemLocations.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobItemLocations.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobItemLocations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobItemLocations.toObject = function(includeInstance, msg) {
  var f, obj = {
    locationsList: jspb.Message.toObjectList(msg.getLocationsList(),
    proto.cloud.JobItemLocations.Location.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobItemLocations}
 */
proto.cloud.JobItemLocations.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobItemLocations;
  return proto.cloud.JobItemLocations.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobItemLocations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobItemLocations}
 */
proto.cloud.JobItemLocations.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.cloud.JobItemLocations.Location;
      reader.readMessage(value,proto.cloud.JobItemLocations.Location.deserializeBinaryFromReader);
      msg.addLocations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobItemLocations.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobItemLocations.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobItemLocations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobItemLocations.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.cloud.JobItemLocations.Location.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.cloud.JobItemLocations.Location.prototype.toObject = function(opt_includeInstance) {
  return proto.cloud.JobItemLocations.Location.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.cloud.JobItemLocations.Location} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobItemLocations.Location.toObject = function(includeInstance, msg) {
  var f, obj = {
    folder: (f = msg.getFolder()) && drive_pb.VolumeFolder.toObject(includeInstance, f),
    subPath: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.cloud.JobItemLocations.Location}
 */
proto.cloud.JobItemLocations.Location.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.cloud.JobItemLocations.Location;
  return proto.cloud.JobItemLocations.Location.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.cloud.JobItemLocations.Location} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.cloud.JobItemLocations.Location}
 */
proto.cloud.JobItemLocations.Location.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new drive_pb.VolumeFolder;
      reader.readMessage(value,drive_pb.VolumeFolder.deserializeBinaryFromReader);
      msg.setFolder(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.cloud.JobItemLocations.Location.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.cloud.JobItemLocations.Location.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.cloud.JobItemLocations.Location} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.cloud.JobItemLocations.Location.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFolder();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      drive_pb.VolumeFolder.serializeBinaryToWriter
    );
  }
  f = message.getSubPath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional VolumeFolder folder = 1;
 * @return {?proto.cloud.VolumeFolder}
 */
proto.cloud.JobItemLocations.Location.prototype.getFolder = function() {
  return /** @type{?proto.cloud.VolumeFolder} */ (
    jspb.Message.getWrapperField(this, drive_pb.VolumeFolder, 1));
};


/**
 * @param {?proto.cloud.VolumeFolder|undefined} value
 * @return {!proto.cloud.JobItemLocations.Location} returns this
*/
proto.cloud.JobItemLocations.Location.prototype.setFolder = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.cloud.JobItemLocations.Location} returns this
 */
proto.cloud.JobItemLocations.Location.prototype.clearFolder = function() {
  return this.setFolder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.cloud.JobItemLocations.Location.prototype.hasFolder = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string sub_path = 2;
 * @return {string}
 */
proto.cloud.JobItemLocations.Location.prototype.getSubPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.cloud.JobItemLocations.Location} returns this
 */
proto.cloud.JobItemLocations.Location.prototype.setSubPath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Location locations = 1;
 * @return {!Array<!proto.cloud.JobItemLocations.Location>}
 */
proto.cloud.JobItemLocations.prototype.getLocationsList = function() {
  return /** @type{!Array<!proto.cloud.JobItemLocations.Location>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.cloud.JobItemLocations.Location, 1));
};


/**
 * @param {!Array<!proto.cloud.JobItemLocations.Location>} value
 * @return {!proto.cloud.JobItemLocations} returns this
*/
proto.cloud.JobItemLocations.prototype.setLocationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.cloud.JobItemLocations.Location=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cloud.JobItemLocations.Location}
 */
proto.cloud.JobItemLocations.prototype.addLocations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.cloud.JobItemLocations.Location, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.cloud.JobItemLocations} returns this
 */
proto.cloud.JobItemLocations.prototype.clearLocationsList = function() {
  return this.setLocationsList([]);
};


goog.object.extend(exports, proto.cloud);
